var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionalDetailsOutletForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.5,
    height: 36.5,
    viewBox: "0 0 36.5 36.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63261",
    "data-name": "Group 63261",
    transform: "translate(-620.75 -348.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1740",
    "data-name": "Ellipse 1740",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(621 349)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63263",
    "data-name": "Group 63263",
    transform: "translate(631.113 357.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221847",
    "data-name": "Path 221847",
    d: "M15.8,2.77H14.39a1.385,1.385,0,0,0-1.357-1.108h-.277a1.662,1.662,0,1,0-3.324,0H9.155A1.385,1.385,0,0,0,7.8,2.77H6.385A1.385,1.385,0,0,0,5,4.155V16.344a1.385,1.385,0,0,0,1.385,1.385H15.8a1.385,1.385,0,0,0,1.385-1.385V4.155A1.385,1.385,0,0,0,15.8,2.77ZM9.155,2.216h.554a.277.277,0,0,0,.277-.277V1.662a1.108,1.108,0,1,1,2.216,0v.277a.277.277,0,0,0,.277.277h.554a.831.831,0,1,1,0,1.662H9.155a.831.831,0,1,1,0-1.662Zm7.479,14.128a.831.831,0,0,1-.831.831H6.385a.831.831,0,0,1-.831-.831V4.155a.831.831,0,0,1,.831-.831H7.8A1.385,1.385,0,0,0,9.155,4.432h3.878A1.385,1.385,0,0,0,14.39,3.324H15.8a.831.831,0,0,1,.831.831ZM9.155,6.094h3.324a.277.277,0,0,0,0-.554H9.155a.277.277,0,0,0,0,.554ZM13.78,8.311H7.028a.277.277,0,1,0,0,.554H13.78a.277.277,0,0,0,0-.554Zm0,1.108H7.028a.277.277,0,1,0,0,.554H13.78a.277.277,0,0,0,0-.554Zm-2.449,2.9h-4.3a.277.277,0,0,0,0,.554h4.3a.277.277,0,0,0,0-.554Zm0,1.108h-4.3a.277.277,0,0,0,0,.554h4.3a.277.277,0,0,0,0-.554Z",
    transform: "translate(-5 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63262",
    "data-name": "Group 63262",
    transform: "translate(7.912 10.883)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1741",
    "data-name": "Ellipse 1741",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(-0.025 0.472)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221846",
    "data-name": "Path 221846",
    d: "M12.23,11.673V10.279a.279.279,0,0,0-.558,0v1.394H10.279a.279.279,0,0,0,0,.558h1.394v1.394a.279.279,0,0,0,.558,0V12.23h1.394a.279.279,0,0,0,0-.558Z",
    transform: "translate(-7.977 -7.478)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDetailsOutletForm);
export default __webpack_public_path__ + "static/media/additionalDetailsOutletForm.82b5651c084bffbe2da673a10ae1aa45.svg";
export { ForwardRef as ReactComponent };